import { lazy } from 'react'
import lazyLoad from './LazyLoad'

// ubox详情相关
export const universeBoxRouter = [
  {
    element: lazyLoad(lazy(() => import('@/pages/universeBox/detail'))),
    path: '/universeBox/detail',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/universeBox/simpleDetail'))),
    path: '/universeBox/simpleDetail',
  },
]